import { AsyncReturnType, TupleToUnion } from 'type-fest';

export const filterCachedListResponse = <T, P>(
	list: T[],
	searchKeys: (keyof T)[],
	param?: P,
): T[] => !param ? list : list.filter(item =>
	searchKeys.some(searchKey =>
		String(item[searchKey] || '').includes(String(param))));


export const cacheListRequest = <F extends (...args: any[]) => Promise<any[]>>(
	request: F,
	searchKeys: (keyof TupleToUnion<AsyncReturnType<F>>)[],
	paramKey?: keyof NonNullable<Parameters<F>[0]>
) => {
	let list: TupleToUnion<AsyncReturnType<F>>[] = [];

	const cachedRequest = async (
		...params: Parameters<F>
	): Promise<typeof list> => {
		if (!list.length)
			list = await request(...params);

		return filterCachedListResponse(
			list,
			searchKeys,
			params && paramKey && params[0] && params[0][paramKey]
		);
	};

	cachedRequest.reset = () => {
		list = [];

		return cachedRequest;
	};

	return cachedRequest;
};